import styled from 'styled-components';
import { css } from '/imports/ui/css';

export const SignedOutPageStyled = styled.div`
  ${css.flexVerticalCenter};
  width: 100%;
  .wrapper {
    text-align: center;
    max-width: 100%;
    width: 30rem;
    margin: auto;
    flex: 1;
    ${css.flexVerticalCenter};
    .inner-wrapper {
      ${css.flexVerticalCenter};
      width: 30rem;
      max-width: 100%;
      padding: 0 1rem;
      box-sizing: border-box;
      h2 {
        font-weight: bold;
        margin-bottom: 0.5rem;
        font-size: 1.5rem;
      }
      form {
        ${css.flexVerticalCenter};
        .inputs {
          width: 100%;
          display: flex;
          flex-direction: column;
          margin-bottom: 2rem;
          input {
            width: 100%;
          }
        }
        label {
        }
        .form-error {
          padding: 0 0.5rem;
          color: ${css.red2};
          border-left: 3px solid ${css.red2};
        }
      }
      .logo {
        height: 4rem;
        margin-bottom: 1rem;
        max-width: 100%;
        ${css.mobileMedia} {
          width: 3rem;
          padding: 1rem;
        }
        img {
          width: 100%;
        }
      }
      .input {
        ${css.mobileMedia} {
          display: block;
          margin-right: 0;
          margin-bottom: 0.5rem;
          width: 100%;
        }
      }
      button {
        margin: auto;
        margin-top: 1rem;
        width: 100%;
        .button-label {
          text-align: center;
          width: 100%;
        }
      }
      a {
        font-weight: bold;
      }
    }
    .login-error {
      color: ${css.red2};
    }
  }
  .forgot-password {
    color: ${css.primaryColor};
    margin-bottom: 1rem;
  }
  .buttons {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;